module.exports = __webpack_public_path__ + "static/media/bgCustomsClearance.9daaf7fa.jpg";